// a user holds at most one of these at a time
export const GROUP_ASSIGNMENT_KINDS = {
    corporationDirector: 'corporationDirector',
    divisionLeader: 'divisionLeader',
    teamLeader: 'teamLeader',
    teamMember: 'teamMember',
} as const;

export type GROUP_ASSIGNMENT_KIND = (typeof GROUP_ASSIGNMENT_KINDS)[keyof typeof GROUP_ASSIGNMENT_KINDS];
